import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  body?: string;
  cta?: { label: string; to: string };
  sx?: SxProps<Theme>;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, body, cta, sx }) => (
  <Box sx={{
    textAlign: 'center',
    py: 6,
    ...(sx as object),
  }}>
    {icon && <Box sx={{ mb: 1 }}>{icon}</Box>}
    <Typography variant="h3" sx={{ color: 'text.headline', mb: body ? 1 : 2 }}>
      {title}
    </Typography>
    {body && (
      <Typography sx={{ color: 'text.secondary', mb: cta ? 3 : 0 }}>
        {body}
      </Typography>
    )}
    {cta && (
      <Button
        component={RouterLink}
        to={cta.to}
        variant="contained"
        color="primary"
      >
        {cta.label}
      </Button>
    )}
  </Box>
);
